import { useState, useCallback } from "react"
import { format } from "date-fns"
import { navigate } from "gatsby"

import useTracking from "hooks/useTracking"
import { identifyUser } from "utils/identifyUser"

const useWebinarSignup = (webinarId, trackingId) => {
  const [signingUp, setSigningUp] = useState(false)
  const [signedUp, setSignedUp] = useState(false)
  const [error, setError] = useState(null)

  const { track } = useTracking()

  const signupWebinar = useCallback(
    async (email, name, scheduleId, redirect, webinarPlatform = "EverWebinar", webinarQuestion) => {
      setSigningUp(true)
      setError(null)

      let orderId = null

      try {
        if (webinarPlatform === "Crowdcast") {
          const response = await fetch("/api/crowdcast", {
            method: "POST",
            body: JSON.stringify({
              email,
              fullName: name,
              webinarId,
            }),
          })

          const userData = await response.json()
          if (userData) {
            const { user } = userData
            try {
              await identifyUser({ user })
            } catch (err) {
              console.log(err)
            }
          }

          if (!response.ok) {
            setError(true)
          } else {
            setSignedUp(true)
          }
        } else {
          const obj = {
            email,
            firstName: name,
            scheduleId,
            time: format(new Date(), "yyyy-MM-dd'T'kk:mm:ssXXX"),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          }
          if (webinarQuestion) obj.webinarQuestion = webinarQuestion
          const response = await fetch(`/api/webinars/register?id=${webinarId}`, {
            method: "POST",
            credentials: "include",
            headers: {
              "CSRF-Token": csrf,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(obj),
          })

          if (!response.ok) {
            throw new Error(response.statusText)
          }

          const data = await response.json()
          setSignedUp(data.confirmationUrl)
          orderId = data.orderId

          try {
            const d = window.gtmDataLayer || window.dataLayer || []
            d.push({ event: "Webinar Registered" })
          } catch (err) {
            //
          }
        }
      } catch (err) {
        setError(true)
        console.error(err)
      }

      track("Webinar Registered", {
        webinarId,
        element_id: trackingId,
        email_address: email,
        webinarPlatform,
        ...(orderId && { registration_id: orderId }),
      })

      if (redirect) {
        navigate(redirect)
      }

      setSigningUp(false)
    },
    [webinarId],
  )

  return [signingUp, signedUp, error, signupWebinar]
}

export default useWebinarSignup
